





























































































































































































































import { Component, Vue, Prop, Provide, Watch, Emit, Ref } from 'vue-property-decorator';
import { TabCard } from "@/components/Tab/index";
import InfoPrompt from '@/components/Prompt/InfoPrompt.vue';
import {
  uploadFaceImage,
  postFaceLibraryFace,
  putFaceLibraryFace,
} from '@/service/project-management/face-library';
import { ElForm } from 'element-ui/types/form';
import { ElDrawer } from 'element-ui/types/drawer';
import { imageCompress, validateFile } from '@/util/file';
import { OperateFaceFormType } from '@/views/ProjectManagement/FaceLibrary/components/types';
import { FaceType } from '@/views/ProjectManagement/FaceLibrary/types';
import { SEX_LIST, VISIT_REASON_OPTIONS } from '@/views/ProjectManagement/FaceLibrary/config';
import { phoneNumberRegExp, validateIdCard, carNumberRegExp } from '@/util';
import { FACE_LIBRARY_MODE_MAP } from '@/views/ProjectManagement/FaceLibrary/config';
import moment from 'moment';
import R from '@/service/operation-platform/visitor';

@Component({
    components: {
        TabCard,
        InfoPrompt,
    },
})
export default class OperateDrawer extends Vue {
    refresh = false;
    uploadImageIndex: number = 0;

    @Ref() readonly formEl!: ElForm;
    @Ref() readonly uploadInputEl!: HTMLInputElement;
    @Ref() readonly drawer!: ElDrawer;

    @Prop()
    data!: FaceType;
    @Prop()
    visible!: boolean;
    @Prop()
    currentFaceGroupType!: string;
    @Prop()
    faceGroupList!: any;
    @Prop()
    defaultImgSet!: any;
    @Prop()
    currentFaceGroupId!: any;
    @Prop()
    currentVisitorFaceId!: any;

    get currentFaceLibraryID() {
        return this.currentFaceGroupId;
    }

    get isAttendanceMode() {
      return this.faceGroupType === FACE_LIBRARY_MODE_MAP.ATTENDANCE;
    }

    get isVipMode() {
      return this.faceGroupType === FACE_LIBRARY_MODE_MAP.VIP;
    }

    get isVisitMode() {
      return this.faceGroupType === FACE_LIBRARY_MODE_MAP.VISIT;
    }

    get isOthersMode() {
      return this.faceGroupType === FACE_LIBRARY_MODE_MAP.OTHERS;
    }

    get isEdited() {
        return !!(this.data && this.data.id);
    }

    get title() {
        return `${this.isEdited ? '编辑' : '新增'}人脸`;
    }

    get uploading() {
        return item => {
            return item.percentage !== 100;
        }
    }

    get srcList() {
        return this.form.faceImgs.map(i => i.src);
    }

    get uploadToast() {
        return item => {
            if (typeof item.error === 'string') {
                return `<i class="if-icon if-md if-icon-error-toast"></i><br>
                       <span class="error">${item.error}</span>`
            } else {
                return item.error === false
                    ? `<i class="if-icon if-md if-icon-success-toast"></i><br>
                      <span class="success">上传成功</span>`
                    : '';
            }
        }
    }

    faceGroupType = '';
    @Provide()
    loading = false;
    @Provide()
    drawerVisible: boolean = false;
    @Provide()
    maxFaceImgLength = 3;
    @Provide()
    form: OperateFaceFormType = {
        faceImgs: [],
        name: '',
        gender: '',
        id: '',
        phone: '',
        visitReason: '',
        visitTime: null,
        visitPersons: null,
        idNo: '',
        birthDay: null,
        entryTime: null,
        welcomeWords: '',
        byeWords: '',
        carNo: '',
    };
    @Provide()
    rules = {
        faceImgs: [
            { required: true, message: '请上传人脸正面照', trigger: 'blur' },
            { validator: this.validateFaceImg, trigger: 'blur' },
        ],
        name: [
            { required: true, message: '请输入对该人的适合称呼', trigger: 'blur' },
            { validator: this.validateName, trigger: 'blur' },
        ],
        gender: [
            { required: true, message: '请选择性别' },
        ],
        id: [
            { required: true, message: '请选择工号', trigger: 'blur' },
            { validator: this.validateID, trigger: 'blur' },
        ],
        phone: [
            { required: true, message: '请输入手机号', trigger: 'blur'},
            { message: '请输入11位手机号码', trigger: 'blur', pattern: phoneNumberRegExp() },
        ],
        visitReason: [
            { required: true, message: '请选择来访目的', trigger: 'change'},
        ],
        visitTime: [
            { required: true, message: '请选择到访时间', trigger: 'change'},
        ],
        idNo: [],
        birthDay: [
            { required: true, message: '请选择生日时间', trigger: 'change'},
        ],
        entryTime: [
            { required: true, message: '请选择入职时间', trigger: 'change'},
        ],
        welcomeWords: [
            { required: true, message: '请输入对该人的适合称呼，及欢迎语', trigger: 'blur' },
        ],
        carNo: [
            { message: '请输入正确的车牌号', trigger: 'blur', pattern: carNumberRegExp() },
        ],
    };
    @Provide()
    options = {
        genderOptions: SEX_LIST,
        visitReason: VISIT_REASON_OPTIONS,
    };
    // 默认图片是否识别失败
    defaultImgFailSet = {
        fail: false,
        msg: '',
    };
    

    @Watch('visible', { immediate: true })
    visibleChange(n) {
        this.drawerVisible = n;
        if (n) {
            this.resetDefaultImgSet();
            this.faceGroupType = this.currentFaceGroupType;
            this.init();
            setTimeout(() => {
                this.setDefaultImg();
            }, 300);
        }
    }

    @Watch('faceGroupType')
    onFaceGroupChange(n) {
      this.init();
    }

    @Emit('close')
    handleClose() {
        return this.refresh;
    }

    resetDefaultImgSet() {
        this.defaultImgFailSet = {
            fail: false,
            msg: '',
        };
    }

    resetForm() {
        this.form.faceImgs = [];
        this.form.name = '';
        this.form.gender = this.options.genderOptions[0].value;
        this.form.id = '';
        this.form.phone = '';
        this.form.visitReason = this.options.visitReason[0].value;
        this.form.visitTime = null;
        this.form.visitPersons = null;
        this.form.idNo = '';
        this.form.birthDay = null;
        this.form.entryTime = null;
        this.form.welcomeWords = '';
        this.form.byeWords = '';
        this.form.carNo = '';
        this.$nextTick(() => {
            if (this.formEl) {
                this.formEl.clearValidate();
            }
        });
    }

    resetRules() {
        const idNoRule: any[] = [
            { validator: this.validateIdCard, trigger: 'blur' },
        ];
        if (!this.isVipMode) {
            idNoRule.push({ required: !this.isVipMode, message: '请输入身份证号', trigger: 'blur'});
        }
        this.rules.idNo = idNoRule;
    }
    
    setDefaultImg() {
      const defaultImgFile = this.defaultImgSet.file;
      const params = {
        target: {
          files: [defaultImgFile]
          }
      }
      this.uploadImageIndex = this.form.faceImgs.length;
      this.handleUploadImgChange(params, true);
    }

    init() {
        this.resetForm();
        this.resetRules();
        this.refresh = false;
        if (Object.keys(this.data).length > 0) {
            const {
                images = [],
                imagesSrc = [],
                name, sex, faceId,
                phone, visitReason, visitTime, idNo,
                entryTime, birthDay, welcomeWords, byeWords,
                visitPersons, carNo
            } = this.data;
           if (imagesSrc.length > 0) {
               this.setFaceImgs();
           } else {
               this.form.faceImgs = Array(images.length).fill(null);
           }
           this.form.name = name;
           this.form.gender = sex;
           this.form.id = faceId;
           this.form.phone = phone;
           this.form.visitReason = visitReason;
           this.form.visitTime = visitTime ? visitTime * 1000 : null;
           this.form.idNo = idNo;
           this.form.entryTime = entryTime ? entryTime * 1000 : null;
           this.form.birthDay = birthDay ? birthDay * 1000 : null;
           this.form.welcomeWords = welcomeWords;
           this.form.byeWords = byeWords;
           this.form.visitPersons = visitPersons ? visitPersons : null;
           this.form.carNo = carNo ? carNo : null;
        }
        this.$nextTick(() => {
            this.formEl.$el.scrollTop = 0;
        });
    }

    setFaceImgs() {
        const { imagesSrc } = this.data;
        this.form.faceImgs = imagesSrc.map(i => {
            return {
                id: i.id,
                percentage: 100,
                src: i.src,
                md5: i.md5,
                error: false,
            };
        })
    }

    handleUploadImg(index = null) {
        this.uploadImageIndex = _.isNumber(index) ? index : this.form.faceImgs.length;
        this.uploadInputEl.value = null;
        this.uploadInputEl.click();
    }

    handleUploadImgChange({target: {files}}, isDefaultUpload: boolean = false) {
        const file = files[0];
        const uploadImageIndex = this.uploadImageIndex;
        const handleError = () => {
            if (!this.form.faceImgs[uploadImageIndex].id) {
                this.form.faceImgs.splice(uploadImageIndex, 1);
            }
        };
        const initItem = {
            id: '',
            percentage: 0,
            src: '',
            md5: '',
            error: true,
        };
        // new
        if (uploadImageIndex > this.form.faceImgs.length - 1) {
            this.form.faceImgs.push(initItem);
        } else {
            this.form.faceImgs.splice(uploadImageIndex, 1, initItem);
        }
        validateFile(file, {
            accept: ['jpg','jpeg','png', 'bmp'],
            size: 2 * 1024 * 1024, // 2M
            unique: this.form.faceImgs.filter(i => i.md5).map(i => i.md5),
        }).then(async (options) => {
            try {
                const { dataUrl, blob } = await imageCompress(file, 20);
                const formData = new FormData();
                formData.append('file', blob, file.name);
                const config = {
                    onUploadProgress: progressEvent => {
                        const complete = (progressEvent.loaded / progressEvent.total * 100 | 0);
                        const item = this.form.faceImgs[uploadImageIndex];
                        // 1%后端检验
                        item.percentage = complete === 100 ? 99 : complete;
                        // this.form.faceImgs.splice(uploadImageIndex, 1, item);
                    },
                };
                uploadFaceImage(formData, config).then(({ data }) => {
                    this.form.faceImgs.splice(uploadImageIndex, 1, {
                        id: data,
                        percentage: 100,
                        src: dataUrl,
                        md5: options.unique,
                        error: false,
                    });
                }).catch(e => {
                    if (e) {
                        const { status, message = '上传失败' } = e;
                        if (status === -1) {
                            this.form.faceImgs.splice(uploadImageIndex, 1, {
                                id: _.uniqueId('fail'),
                                percentage: 100,
                                src: dataUrl,
                                md5: options.unique,
                                error: message,
                            });
                            this.defaultImgFailSet = {
                                fail: true,
                                msg: message,
                            };
                            return;
                        } else {
                            this.$message.error(e.message);
                        }
                    }
                    handleError();
                }).finally(() => {
                    this.formEl.validateField('faceImgs');
                });
            } catch (e) {
                handleError();
                this.$message.error('图片解析出错，请重试');
            }
        }).catch(e => {
            handleError();
            this.$message.error(e);
        })
    }

    handlePreviewUploadImg(id) {
        this.$refs[`uploadImg${id}`] && this.$refs[`uploadImg${id}`][0].clickHandler();
    }

    handleDeleteImg(id) {
        this.form.faceImgs.splice(
            _.findIndex(this.form.faceImgs, { id }),
            1,
        );
    }

    async beforeDrawerClose(done) {
        if (this.defaultImgFailSet.fail) {
            this.loading = true;
            const params = {
                errorMsg: this.defaultImgFailSet.msg,
                recordId: this.defaultImgSet.face.id,
            };
            try {
                await R.setFailRecord(params);
                this.$emit('submit');
            } catch (err) {
                this.$message.error(err.message);
            }
            this.loading = false;
        }
        done();
    }

    handleCancel() {
        this.drawer.closeDrawer();
    }

    handleSubmit() {
        this.formEl.validate(valid => {
            if (valid) {
                if (this.form.faceImgs.filter(i => !i.id).length > 0) {
                    this.$message.error('请等待人脸照完成上传');
                    return;
                }
                const data = this.getSubmitData();
                if (this.isEdited) {
                    this.putFaceLibraryFace(data);
                } else {
                    this.postFaceLibraryFace(data);
                }
            } else {
                return;
            }
        });
    }

    getSubmitData() {
        const data = {
            groupId: this.currentFaceLibraryID,
            images: this.form.faceImgs.map(i => i.id),
        };
        if (this.isAttendanceMode) {
            Object.assign(data, {
                name: this.form.name,
                sex: this.form.gender,
                faceId: this.form.id,
                phone: this.form.phone,
                idNo: this.form.idNo,
                entryTime: this._getDateTimestamp(this.form.entryTime),
                birthDay: this._getDateTimestamp(this.form.birthDay),
            });
        } else if (this.isVipMode) {
            Object.assign(data, {
                sex: this.form.gender,
                welcomeWords: this.form.welcomeWords,
                byeWords: this.form.byeWords,
                idNo: this.form.idNo,
            });
        } else if (this.isVisitMode) {
            Object.assign(data, {
                visitReason: this.form.visitReason,
                name: this.form.name,
                sex: this.form.gender,
                phone: this.form.phone,
                visitTime: moment(this.form.visitTime).set('second', 0) / 1000,
                idNo: this.form.idNo,
                visitPersons: this.form.visitPersons ? this.form.visitPersons : null,
                carNo: this.form.carNo,
            });
        } else if (this.isOthersMode) {
            Object.assign(data, {
                name: this.form.name,
                sex: this.form.gender,
            });
        }
        return data;
    }

    postFaceLibraryFace(data) {
        this.loading = true;
        Object.assign(data, { src: 'platform' });
        postFaceLibraryFace(data)
        .then(({ data: {id} }) => {
            const params = {
                faceId: id,
                id: this.currentVisitorFaceId,
            };
            return R.bindFaceLibWithVisitorRecord(params);
        })
        .then(() => {
            this.$message.success('成功创建人脸');
            this.$emit('submit');
        })
        .catch(err => {
            this.loading = false;
            this.$message.error(err.message);
        }).finally(() => {
            this.loading = false;
        });
    }

    putFaceLibraryFace(data) {
        const putData = Object.assign({}, data, {
            id: this.data.id,
        });
        this.loading = true;
        putFaceLibraryFace(putData).then(() => {
            this.$message.success('成功更新人脸');
            this.$emit('submit');
        }).finally(() => {
            this.loading = false;
        });
    }

    validateFaceImg(rule, value, callback) {
        if (value.filter(i => _.isString(i.error)).length > 0) {
            callback(new Error(' '));
        } else {
            callback();
        }
    }

    validateName(rule, value, callback) {
        if (!/^[a-zA-Z\u4e00-\u9fa5]+$/.test(value)) {
            callback(new Error('请输入中英文'));
        } else {
            callback();
        }
    }

    validateID(rule, value, callback) {
        if (value && !/^[a-zA-Z0-9]+$/.test(value)) {
            callback(new Error('请输入数字或者英文'));
        } else {
            callback();
        }
    }

    validateIdCard(rule, value, callback) {
        try {
            if (value) {
                validateIdCard(value);
            }
            callback();
        } catch (e) {
            callback(e);
        }
    }

    _getDateTimestamp(time) {
        return moment(moment(time).format('YYYY-MM-DD')).valueOf() / 1000;
    }
}
